import React from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

const FineTextStyle = styled.div`
  p {
    font-size: 0.65rem;
  }
`;

const FineText: React.FC = () => {
  const { t } = useTranslation();
  return (
    <FineTextStyle>
      <p>{t(($) => $.pageContractSummaryEcomm.fineTextFees)}</p>
      <p>{t(($) => $.pageContractSummaryEcomm.fineTextLeaseTerm)}</p>
      <p>{t(($) => $.pageContractSummaryEcomm.fineTextPaymentRights)}</p>
      <p>{t(($) => $.pageContractSummaryEcomm.fineTextBankHoliday)}</p>
    </FineTextStyle>
  );
};

export default FineText;
